import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { PipesModule } from '../../theme/pipes/pipes.module';
import { Menu2Component } from './menu2.component';
import { Menu2SingleComponent } from './menu2-single/menu2-single.component';



export const routes: Routes = [
  { path: "", component: Menu2Component, pathMatch: "full" },
  { path: ":id", component: Menu2SingleComponent },
];

@NgModule({
  declarations: [Menu2Component,Menu2SingleComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    PipesModule,
  ],
})
export class Menu2Module {}
